export default __webpack_public_path__ + "static/media/livingroom4.bb24fcf3.webp";